import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Session is carried by an HttpOnly Secure cookie (set by the backend on login).
// No auth token is stored in localStorage / sessionStorage or read by JS.
const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes("/login")) {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(err) {
  const d = err.response?.data?.detail;
  if (d == null) return err.message || "Terjadi kesalahan";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export default api;
